module.exports = __webpack_public_path__ + "media/images/icons/euro-b1c02c92cded9f8138a02fe920d9dc85.svg";